module.exports = __webpack_public_path__ + "img/default.c4458c39.png";